import { combineReducers } from 'redux-immutable'
import sidebarCollapseReducer from './sidebar-collapse-reducer'
import sidebarDockedReducer from './sidebar-docked-reducer'

export default combineReducers({
  sidebarCollapse: sidebarCollapseReducer,
  sidebarDocked: sidebarDockedReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/sidebar/index.js